const Footer = () => {
    return (
            <footer className="footer">
                <div>
                   <h4>© 2021 Copyright: WebDev Digest </h4>
                </div>
            </footer>
    );
}

export default Footer;